import classnames from "classnames";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import Customizer from "../components/@vuexy/customizer/customizer";
import {
  changeFooterType,
  changeMenuColor,
  changeMode,
  changeNavbarColor,
  changeNavbarType,
  collapseSidebar,
  hideScrollToTop,
} from "../redux/actions/customizer/index";
import Footer from "./components/footer/footer";
import HorizontalSidebar from "./components/menu/horizontal-menu/horizontalMenu";
import VerticalSidebar from "./components/menu/vertical-menu/sidebar";
import Navbar from "./components/navbar/navbar";

/**
 * FullLayout class represents a React component that defines the layout of the application.
 * It includes methods to handle sidebar visibility, customizer settings, and layout changes based on user interactions.
 * The class manages the state of the sidebar, customizer, width of the window, and scroll position.
 * It also renders the Navbar, Sidebar, Footer, and Customizer components based on the application's customizer settings.
 */
class FullLayout extends PureComponent {
  state = {
    width: window.innerWidth,
    sidebarState: false,
    collapsedContent: false,
    sidebarHidden: false,
    customizer: false,
  };

  updateWidth = () => {
    this.setState((prevState) => ({
      width: window.innerWidth,
    }));
  };

  updateScroll = () => {
    this.setState({ scroll: window.scrollY });
  };

  handleCustomizer = (bool) => {
    this.setState({
      customizer: bool,
    });
  };

  handleRouteChange = () => {
    this.setState({
      sidebarState: false,
      collapsedContent: false,
    });
  };

  componentDidMount() {
    if (window !== "undefined") {
      window.addEventListener("resize", this.updateWidth, false);
      window.addEventListener("scroll", this.updateScroll, false);
    }
    let layout = this.props.app.customizer.theme;
    return layout === "dark"
      ? document.body.classList.add("dark-layout")
      : layout === "semi-dark"
        ? document.body.classList.add("semi-dark-layout")
        : null;
  }

  componentDidUpdate() {
    this.handleRouteChange();

    let layout = this.props.app.customizer.theme;
    if (layout === "dark") {
      document.body.classList.remove("semi-dark-layout");
      document.body.classList.add("dark-layout");
    } else if (layout === "semi-dark") {
      document.body.classList.remove("dark-layout");
      document.body.classList.add("semi-dark-layout");
    } else {
      return document.body.classList.remove("dark-layout", "semi-dark-layout");
    }
  }

  toggleSidebarMenu = (collapsedValue = null) => {
    this.setState((prevState) => {
      const newCollapsed =
        collapsedValue !== null ? collapsedValue : !prevState.collapsedContent;

      return {
        collapsedContent: newCollapsed,
        sidebarState: newCollapsed ? false : prevState.sidebarState,
      };
    });
  };

  sidebarMenuHover = (val) => {
    this.setState({
      sidebarState: val,
    });
  };

  handleSidebarVisibility = () => {
    window.addEventListener("resize", () => {
      if (this.state.sidebarHidden) {
        this.setState({
          sidebarHidden: !this.state.sidebarHidden,
        });
      }
    });
    this.setState({
      sidebarHidden: !this.state.sidebarHidden,
    });
  };

  handleCollapsedMenuPaths = (item) => {
    let collapsedPaths = this.collapsedPaths;
    if (!collapsedPaths.includes(item)) {
      collapsedPaths.push(item);
      this.collapsedPaths = collapsedPaths;
    }
  };

  render() {
    let customizerProps = this.props.app.customizer;
    let navbarTypeArr = ["sticky", "static", "sticky", "floating", "hidden"];
    let menuThemeArr = [
      "primary",
      "success",
      "danger",
      "info",
      "warning",
      "dark",
    ];
    let sidebarProps = {
      toggleSidebarMenu: this.props.collapseSidebar,
      toggle: this.toggleSidebarMenu,
      sidebarState: this.state.sidebarState,
      sidebarHover: this.sidebarMenuHover,
      sidebarVisibility: this.handleSidebarVisibility,
      visibilityState: this.state.sidebarHidden,
      activePath: window.location.pathname,
      collapsedMenuPaths: this.handleCollapsedMenuPaths,
      activeTheme: customizerProps.menuTheme,
      collapsed: this.state.collapsedContent,
      deviceWidth: this.state.width,
    };
    return (
      <div
        className={
          this.state.width >= 1200
            ? classnames(
                `wrapper horizontal-layout theme-${customizerProps.menuTheme}`,
                {
                  "menu-collapsed":
                    this.state.collapsedContent === true &&
                    this.state.width > 1200,
                  "fixed-footer": customizerProps.footerType === "sticky",
                  "navbar-static": customizerProps.navbarType === "static",
                  "navbar-sticky": customizerProps.navbarType === "sticky",
                  "navbar-floating":
                    customizerProps.navbarType === "floating" ||
                    !navbarTypeArr.includes(customizerProps.navbarType),
                  "navbar-hidden": customizerProps.navbarType === "hidden",
                  "theme-primary": !menuThemeArr.includes(
                    customizerProps.menuTheme,
                  ),
                },
              )
            : classnames(
                `wrapper vertical-layout theme-${customizerProps.menuTheme}`,
                {
                  "menu-collapsed":
                    this.state.collapsedContent === true &&
                    this.state.width >= 1200,
                  "fixed-footer": customizerProps.footerType === "sticky",
                  "navbar-static": customizerProps.navbarType === "static",
                  "navbar-sticky": customizerProps.navbarType === "sticky",
                  "navbar-floating": customizerProps.navbarType === "floating",
                  "navbar-hidden": customizerProps.navbarType === "hidden",
                  "theme-primary": !menuThemeArr.includes(
                    customizerProps.menuTheme,
                  ),
                },
              )
        }
      >
        {this.state.width >= 1200 && (
          <HorizontalSidebar
            activePath={window.location.pathname}
            navbarType={customizerProps.navbarType}
          />
        )}
        {this.state.width < 1200 && <VerticalSidebar {...sidebarProps} />}
        <div className={classnames("app-content content")}>
          <Navbar
            horizontal
            scrolling={this.state.scroll > 50 ? true : false}
            sidebarVisibility={this.handleSidebarVisibility}
            navbarColor={customizerProps.navbarColor}
            navbarType={customizerProps.navbarType}
          />
          <div className="content-wrapper">{this.props.children}</div>
        </div>
        <Footer footerType={customizerProps.footerType} />
        {customizerProps.disableCustomizer !== true ? (
          <Customizer
            scrollToTop={customizerProps.hideScrollToTop}
            activeNavbar={customizerProps.navbarColor}
            activeMode={customizerProps.theme}
            navbarType={customizerProps.navbarType}
            footerType={customizerProps.footerType}
            menuTheme={customizerProps.menuTheme}
            customizerState={this.state.customizer}
            handleCustomizer={this.handleCustomizer}
            changeNavbar={this.props.changeNavbarColor}
            changeNavbarType={this.props.changeNavbarType}
            changeFooterType={this.props.changeFooterType}
            changeMenuTheme={this.props.changeMenuColor}
            hideScrollToTop={this.props.hideScrollToTop}
            changeMode={this.props.changeMode}
          />
        ) : null}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    app: state.customizer,
  };
};
export default connect(mapStateToProps, {
  changeNavbarColor,
  changeNavbarType,
  changeFooterType,
  changeMenuColor,
  hideScrollToTop,
  changeMode,
  collapseSidebar,
})(FullLayout);
